module.exports = __webpack_public_path__ + "img/L_312_0.17c32a3c.png";